var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixExpired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 255,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#9FCDFF",
    d: "m203.018,190.736l-13.837,-14.19c-0.636,-0.651 -0.893,-1.576 -0.704,-2.484c1.888,-8.775 2.472,-18.046 1.51,-27.591c-4.223,-41.935 -38.215,-75.4205 -80.276,-79.1222c-15.4338,-1.3538 -30.095,1.2853 -43.1253,6.9406c-1.0816,0.4627 -2.3177,0.2399 -3.1417,-0.5998l-9.2878,-9.5111c-0.9785,-0.994 -2.5065,-1.3881 -3.7597,-0.7712c-2.0773,1.0454 -2.3863,3.6159 -0.9271,5.124l9.511,9.751c2.9871,3.0504 3.588,7.0434 0.6523,9.9052c-2.9357,2.8619 -6.8671,2.4335 -9.8542,-0.6169l-12.3952,-13.2984c-2.9185,-2.9133 -7.6224,-2.9133 -10.5409,0c-2.9186,2.9133 -2.9186,7.6089 0,10.5222l12.1719,12.0302c2.9872,3.0504 2.9185,7.9514 -0.1374,10.9334c-3.0558,2.982 -7.9658,2.913 -10.953,-0.137l-9.6483,-9.9909c-4.4292,-4.5413 -11.91437,-4.3014 -16.01746,0.7883c-3.43354,4.2496 -2.83267,10.4876 0.99573,14.3956l13.18483,13.504c0.721,0.754 0.9786,1.833 0.6695,2.827c-2.6095,8.329 -4.0344,17.189 -4.0344,26.391c0,32.492 17.5455,60.888 43.6919,76.278l89.9243,0c6.249,-3.685 12.018,-8.089 17.185,-13.145c1.047,-1.028 2.713,-1.028 3.726,0.018l2.54,2.604c3.812,3.908 10.044,4.679 14.387,1.354c5.202,-3.958 5.648,-11.43 1.219,-15.972l-7.022,-7.197l-7.965,-8.26c-2.061,-2.108 -2.026,-5.484 0.103,-7.541c2.111,-2.056 5.493,-2.005 7.553,0.103l5.322,5.484l10.352,10.608c2.73,2.793 7.417,2.553 9.803,-0.788c1.82,-2.571 1.305,-6.101 -0.875,-8.346z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#9FCDFF",
    d: "m168.013,233.527l-141.7201,0c-0.9442,0 -1.7167,-0.771 -1.7167,-1.713c0,-0.943 0.7725,-1.714 1.7167,-1.714l141.7201,0c0.944,0 1.716,0.771 1.716,1.714c0,0.942 -0.772,1.713 -1.716,1.713z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#9FCDFF",
    d: "m102.861,245.506l-53.6491,0c-0.9442,0 -1.7168,-0.771 -1.7168,-1.714c0,-0.942 0.7726,-1.713 1.7168,-1.713l53.6491,0c0.944,0 1.717,0.771 1.717,1.713c0,0.943 -0.756,1.714 -1.717,1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#9FCDFF",
    d: "m160.476,245.506l-33.494,0c-0.944,0 -1.717,-0.771 -1.717,-1.714c0,-0.942 0.773,-1.713 1.717,-1.713l33.511,0c0.945,0 1.717,0.771 1.717,1.713c0,0.943 -0.772,1.714 -1.734,1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#9FCDFF",
    d: "m179.017,255l-86.4909,0c-0.9442,0 -1.7168,-0.771 -1.7168,-1.714c0,-0.942 0.7726,-1.713 1.7168,-1.713l86.4739,0c0.944,0 1.717,0.771 1.717,1.713c0,0.943 -0.756,1.714 -1.7,1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#9FCDFF",
    d: "m69.8476,255l-48.8938,0c-0.9442,0 -1.7167,-0.771 -1.7167,-1.714c0,-0.942 0.7725,-1.713 1.7167,-1.713l48.8938,0c0.9442,0 1.7167,0.771 1.7167,1.713c0,0.943 -0.7554,1.714 -1.7167,1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#9FCDFF",
    d: "m17.5203,233.527l-15.39947,0c-0.94423,0 -1.71678,-0.771 -1.71678,-1.713c0,-0.943 0.77255,-1.714 1.71678,-1.714l15.39947,0c0.9442,0 1.7168,0.771 1.7168,1.714c0,0.942 -0.7726,1.713 -1.7168,1.713z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#9FCDFF",
    d: "m183.446,233.527l-8.377,0c-0.945,0 -1.717,-0.771 -1.717,-1.713c0,-0.943 0.772,-1.714 1.717,-1.714l8.377,0c0.945,0 1.717,0.771 1.717,1.714c0,0.942 -0.772,1.713 -1.717,1.713z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#9FCDFF",
    d: "m197.524,233.527l-6.335,0c-0.944,0 -1.717,-0.771 -1.717,-1.713c0,-0.943 0.773,-1.714 1.717,-1.714l6.335,0c0.944,0 1.717,0.771 1.717,1.714c0,0.942 -0.773,1.713 -1.717,1.713z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#9FCDFF",
    d: "m117.076,245.506l-5.202,0c-0.944,0 -1.717,-0.771 -1.717,-1.714c0,-0.942 0.773,-1.713 1.717,-1.713l5.202,0c0.944,0 1.717,0.771 1.717,1.713c0,0.943 -0.773,1.714 -1.717,1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#9FCDFF",
    d: "m161.901,24.369l-4.223,0l0,-4.2158c0,-0.7711 -0.618,-1.3881 -1.391,-1.3881c-0.772,0 -1.39,0.617 -1.39,1.3881l0,4.2158l-4.224,0c-0.772,0 -1.39,0.6169 -1.39,1.3881c0,0.7711 0.618,1.3881 1.39,1.3881l4.224,0l0,4.2157c0,0.7712 0.618,1.3881 1.39,1.3881c0.773,0 1.391,-0.6169 1.391,-1.3881l0,-4.2157l4.223,0c0.773,0 1.391,-0.617 1.391,-1.3881c0,-0.7712 -0.636,-1.3881 -1.391,-1.3881z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#9FCDFF",
    d: "m138.244,50.2117l-2.919,0l0,-2.9133c0,-0.5312 -0.429,-0.9597 -0.961,-0.9597c-0.532,0 -0.961,0.4285 -0.961,0.9597l0,2.9133l-2.919,0c-0.532,0 -0.961,0.4285 -0.961,0.9597c0,0.5313 0.429,0.9597 0.961,0.9597l2.919,0l0,2.9133c0,0.5312 0.429,0.9597 0.961,0.9597c0.532,0 0.961,-0.4285 0.961,-0.9597l0,-2.9133l2.919,0c0.532,0 0.961,-0.4284 0.961,-0.9597c0,-0.5312 -0.429,-0.9597 -0.961,-0.9597z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "#9FCDFF",
    d: "m88.7665,13.4698c-3.7254,0 -6.747,-3.0162 -6.747,-6.73492c0.0172,-3.71875 3.0387,-6.73488 6.747,-6.73488c3.7082,0 6.7469,3.01613 6.7469,6.73488c0,3.70162 -3.0215,6.73492 -6.7469,6.73492zm0,-11.75609c-2.7812,0 -5.0302,2.24496 -5.0302,5.02117c0,2.77621 2.249,5.02112 5.0302,5.02112c2.7811,0 5.0301,-2.24491 5.0301,-5.02112c0,-2.77621 -2.249,-5.02117 -5.0301,-5.02117z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#9FCDFF",
    d: "m47.8042,36.7077c-3.0215,0 -5.4937,-2.4506 -5.4937,-5.4838c0,-3.0162 2.455,-5.4839 5.4937,-5.4839c3.0215,0 5.4937,2.4506 5.4937,5.4839c0,3.0332 -2.455,5.4838 -5.4937,5.4838zm0,-9.5625c-2.2489,0 -4.0859,1.8337 -4.0859,4.0787c0,2.2449 1.837,4.0786 4.0859,4.0786c2.249,0 4.0859,-1.8337 4.0859,-4.0786c0.0172,-2.245 -1.8197,-4.0787 -4.0859,-4.0787z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "white",
    d: "m36.8339,126.575c-3.7941,0 -6.8671,-3.085 -6.8671,-6.872c0,-3.788 3.0902,-6.872 6.8671,-6.872c3.7941,0 6.8843,3.084 6.8843,6.872c0,3.787 -3.0902,6.872 -6.8843,6.872zm0,-11.517c-2.5752,0 -4.6525,2.091 -4.6525,4.662c0,2.57 2.0945,4.661 4.6525,4.661c2.5752,0 4.6696,-2.091 4.6696,-4.661c0,-2.571 -2.0944,-4.662 -4.6696,-4.662z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#9FCDFF",
    d: "m88.7663,49.0806c-2.2833,0 -4.1374,-1.8508 -4.1374,-4.13c0,-2.2792 1.8541,-4.13 4.1374,-4.13c2.2833,0 4.1375,1.8508 4.1375,4.13c0,2.2792 -1.8542,4.13 -4.1375,4.13zm0,-6.9233c-1.5451,0 -2.7983,1.251 -2.7983,2.7933c0,1.5423 1.2532,2.7933 2.7983,2.7933c1.5451,0 2.7984,-1.251 2.7984,-2.7933c0,-1.5423 -1.2533,-2.7933 -2.7984,-2.7933z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "white",
    d: "m173.369,160.249c-2.283,0 -4.137,-1.851 -4.137,-4.13c0,-2.279 1.854,-4.13 4.137,-4.13c2.283,0 4.138,1.851 4.138,4.13c0,2.279 -1.855,4.13 -4.138,4.13zm0,-6.923c-1.545,0 -2.798,1.251 -2.798,2.793c0,1.542 1.253,2.793 2.798,2.793c1.545,0 2.798,-1.251 2.798,-2.793c0,-1.542 -1.253,-2.793 -2.798,-2.793z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "white",
    d: "m30.0012,152.366l-2.9185,0l0,-2.913c0,-0.532 -0.4292,-0.96 -0.9614,-0.96c-0.5322,0 -0.9614,0.428 -0.9614,0.96l0,2.913l-2.9185,0c-0.5322,0 -0.9614,0.428 -0.9614,0.96c0,0.531 0.4292,0.959 0.9614,0.959l2.9185,0l0,2.914c0,0.531 0.4292,0.959 0.9614,0.959c0.5322,0 0.9614,-0.428 0.9614,-0.959l0,-2.914l2.9185,0c0.5322,0 0.9614,-0.428 0.9614,-0.959c0,-0.532 -0.4292,-0.96 -0.9614,-0.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "white",
    d: "m96.6978,99.1723c-4.8756,0 -8.8414,-3.9586 -8.8414,-8.8256c0,-4.8669 3.9658,-8.8256 8.8414,-8.8256c4.8752,0 8.8412,3.9587 8.8412,8.8256c0,4.867 -3.966,8.8256 -8.8412,8.8256zm0,-14.2238c-2.9872,0 -5.4078,2.4164 -5.4078,5.3982c0,2.9819 2.4378,5.3982 5.4078,5.3982c2.9872,0 5.4082,-2.4163 5.4082,-5.3982c0,-2.9818 -2.421,-5.3982 -5.4082,-5.3982z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "#9FCDFF",
    d: "m13.0739,69.9193l-5.4593,-5.4496c-2.54082,-2.5363 -2.54082,-6.7006 0,-9.254c2.5408,-2.5363 6.7126,-2.5363 9.2706,0l5.4593,5.4496c2.5409,2.5363 2.5409,6.7006 0,9.254c-2.558,2.5363 -6.7297,2.5363 -9.2706,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_34",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    stroke: "#004D7A",
    d: "m135.341,120.926c8.728,9.187 14.103,21.606 14.103,35.296c0,28.298 -22.939,51.222 -51.222,51.222c-28.2831,0 -51.222,-22.939 -51.222,-51.222c0,-28.283 22.9236,-51.222 51.222,-51.222c11.822,0 22.709,3.997 31.376,10.734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "#1E7CB3",
    d: "m98.2369,207.444c28.2891,0 51.2221,-22.933 51.2221,-51.222c0,-28.289 -22.933,-51.222 -51.2221,-51.222c-28.2891,0 -51.222,22.933 -51.222,51.222c0,28.289 22.9329,51.222 51.222,51.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "#016199",
    d: "m98.2374,105c-1.2556,0 -2.4807,0.046 -3.721,0.138c26.5526,1.899 47.5166,24.041 47.5166,51.084c0,27.043 -20.949,49.185 -47.5013,51.084c1.225,0.092 2.4654,0.138 3.721,0.138c28.2983,0 51.2223,-22.939 51.2223,-51.222c0,-28.283 -22.939,-51.222 -51.2376,-51.222z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#004D7A",
    strokeWidth: 2,
    id: "svg_24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m59.62683,169.27945c-1.40846,-4.14805 -2.18228,-8.59023 -2.18228,-13.21737c0,-22.61316 18.32522,-40.93778 40.93768,-40.93778c22.61286,0 40.93748,18.34079 40.93748,40.95294c0,22.61215 -18.32462,40.92262 -40.93748,40.92262c-15.46191,0 -28.91176,-8.57507 -35.87663,-21.22037"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0,
    id: "svg_23",
    fill: "white",
    d: "m60.62174,169.03563c-1.36703,-4.02605 -2.11809,-8.33758 -2.11809,-12.82863c0,-21.94808 17.78625,-39.73374 39.73365,-39.73374c21.94778,0 39.73345,17.80136 39.73345,39.74846c0,21.9471 -17.78566,39.71903 -39.73345,39.71903c-15.00716,0 -28.06142,-8.32287 -34.82145,-20.59625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    fill: "#FCFAFA",
    d: "m90.5193,151.567l8.4987,6.661l0,-18.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    id: "svg_26",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.01743,
    stroke: "#004D7A",
    d: "m90.5193,151.567l8.4987,6.661l0,-18.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.35263,
    stroke: "#004D7A",
    d: "m118.466,137.585l3,-3.582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.35263,
    stroke: "#004D7A",
    d: "m98.2217,129.807l0,-4.686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_29",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.35263,
    stroke: "#004D7A",
    d: "m77.824,137.585l-3.0159,-3.582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.35263,
    stroke: "#004D7A",
    d: "m126.076,158.228l4.686,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.35263,
    stroke: "#004D7A",
    d: "m65.7278,158.228l4.6858,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_32",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.35263,
    stroke: "#004D7A",
    d: "m99.5393,186.19l0,4.685"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_33",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.35263,
    stroke: "#004D7A",
    d: "m79.1568,178.411l-3.0159,3.597"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#004D7A",
    id: "svg_37",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.01743,
    d: "m159.152,223.002c-5.635,4.379 -12.725,6.998 -20.412,6.998c-18.391,0 -33.29,-14.9 -33.29,-33.29c0,-18.391 14.899,-33.291 33.29,-33.291c18.391,0 33.291,14.9 33.291,33.291c0,9.019 -3.584,17.211 -9.418,23.199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_35",
    fill: "#EAB14D",
    d: "m138.74,230c18.386,0 33.291,-14.905 33.291,-33.29c0,-18.386 -14.905,-33.291 -33.291,-33.291c-18.386,0 -33.29,14.905 -33.29,33.291c0,18.385 14.904,33.29 33.29,33.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_36",
    fill: "#E49542",
    d: "m138.74,163.419c-0.934,0 -1.868,0.046 -2.787,0.123c17.074,1.408 30.503,15.726 30.503,33.168c0,17.441 -13.429,31.759 -30.503,33.167c0.919,0.077 1.853,0.123 2.787,0.123c18.391,0 33.29,-14.9 33.29,-33.29c0,-18.376 -14.915,-33.291 -33.29,-33.291z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_38",
    strokeMiterlimit: 10,
    strokeWidth: 3.01743,
    stroke: "#004D7A",
    fill: "#FCFAFA",
    d: "m140.425,203.815l-3.369,0c-1.455,0 -2.634,-1.179 -2.634,-2.634l0,-25.649c0,-1.455 1.179,-2.634 2.634,-2.634l3.369,0c1.455,0 2.634,1.179 2.634,2.634l0,25.649c-0.016,1.455 -1.195,2.634 -2.634,2.634z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_39",
    strokeMiterlimit: 10,
    strokeWidth: 3.01743,
    stroke: "#004D7A",
    fill: "#FCFAFA",
    d: "m140.272,220.521l-3.063,0c-1.317,0 -2.389,-1.072 -2.389,-2.389l0,-6.63c0,-1.317 1.072,-2.389 2.389,-2.389l3.063,0c1.317,0 2.389,1.072 2.389,2.389l0,6.63c-0.016,1.317 -1.072,2.389 -2.389,2.389z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixExpired);
export default __webpack_public_path__ + "static/media/pix-expired.cc7cbab1bac29a0aac5f6e992f2a503f.svg";
export { ForwardRef as ReactComponent };